import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-textalignvertical",
  "use": "icon-textalignvertical-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-textalignvertical\"><path d=\"M910.222222 1024V0h113.777778v1024h-113.777778zM455.111111 227.555556h113.777778v512H455.111111V227.555556zM0 0h113.777778v1024H0V0z\" fill=\"#000000\" p-id=\"4446\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol